import { Rx } from "subtree.js/core";

/** A table the shop has at a show, as the vendor reads it back. */
export interface BookedTable {
  readonly label: string;
  readonly show: string;
  readonly when: string;
  readonly where: string;
}

export class OnboardingShowState {
  readonly storeId = new Rx<string | null>(null);
  /** A table is the shop's: its booth at the show is somewhere to trade from. */
  readonly hasBooth = new Rx(false);
  /** The first table the shop has: one is all the step needs to confirm. */
  readonly table = new Rx<BookedTable | null>(null);
  /** The vendor has no code and is choosing a show to book a table at. */
  readonly booking = new Rx(false);
}

export abstract class OnboardingShowActions {
  abstract startBooking(): void;
  abstract back(): void;
  abstract next(): void;
}
